<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :btnRefreshVisible="true" :btnNewVisible="false"
        :linkConfigurazioni="linkConfigurazione" @refresh="onRefresh">
        <template #toolbar>
            <b-button class="button-new" size="sm" variant="success btn-toolbar float-sm-right sa-margin-right"
                @click="onNew">
                <b-icon icon="plus"></b-icon>
                {{ $t("global.lblBtnNew") }}
            </b-button>
        </template>
        <template #table-filter>
            <div class="sa-list-component-header" style="padding: 5px">
                <div class="sa-page-search-component">
                    <b-form style="width: 100%" @submit.prevent="onSubmit">
                        <!-- <b-row class="sa-form-btn-filter">
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                <label class="sa-label-data">Struttura</label>
                                <div class="sa-page-search-component-wrapper" style="flex: 1; min-width: 70px">
                                    <input class="sa-page-search-component-input"
                                        v-model="filtroTipologieVisite.codiceStruttura" disabled />
                                </div>
                            </b-col>
                            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">

                                <button class="sa-page-search-component-btn-search" title="Search">
                                    <i class="fas fa-search"></i>
                                </button>
                                <button class="sa-page-search-component-btn-reset"
                                    @click="resetFiltriConfigurazioneDevice" type="button"><i
                                        class="fas fa-trash"></i></button>

                            </b-col>
                        </b-row> -->
                    </b-form>
                </div>
            </div>
        </template>
        <template slot="table-body">
            <AgendaSpecializzazioniListComponent ref="cmpAgendaTipologieVisitaListComponent" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from '../../../../template/sa/components/layout/contents/SaPageLayout.vue';
import AgendaSpecializzazioniListComponent from '../components/AgendaSpecializzazioniListComponent.vue';

export default {
    components: { SaPageLayout, AgendaSpecializzazioniListComponent },
    inject: ["openShowModalLoading", "closeShowModalLoading"],

    data() {
        return {
            linkConfigurazione: "/configurazioneagende",
            pathResource: "/agendaspecializzazione",
            filtroSessionStorage: "filtroConfigurazioneAgendaSpecializzazione",
            showModalLoading: false,
            presidio: null,
            struttureOptions: [],
            filtroTipologieVisite: {},

        };
    },
    mounted() {
        let me = this;
        this.getPresidio();
        let sessionStorage = window.sessionStorage;
        me.showModalLoading = true;
        let filtroTipologieVisite = sessionStorage.getItem(this.filtroSessionStorage);

        if (filtroTipologieVisite) {
            me.filtroTipologieVisite = JSON.parse(filtroTipologieVisite);
            if (me.filtroTipologieVisite.codiceStruttura) {
                //me.filtroTipologieVisite.codiceStruttura = this.presidio.codiceStruttura;
            }
        }
        me.loadData(me.filtroTipologieVisite);
    },
    methods: {
        loadData(filtro) {
            let me = this;
            filtro
            me.$refs.cmpAgendaTipologieVisitaListComponent.loadData(filtro);
        },
        onRefresh() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            me.showModalLoading = true;

            let filtroTipologieVisite = sessionStorage.getItem(this.filtroSessionStorage);
            if (filtroTipologieVisite) {
                me.filtroTipologieVisite = JSON.parse(filtroTipologieVisite);
                me.filtroTipologieVisite.codiceStruttura = this.presidio.codiceStruttura;
            }
            me.loadData(me.filtroTipologieVisite);
        },
        getPresidio() {
            let tmpPresidio = window.localStorage.getItem("presidio");
            if (tmpPresidio) {
                this.presidio = JSON.parse(tmpPresidio);
            }
        },
        resetFiltriConfigurazioneDevice() {
            let me = this;
            me.filtroTipologieVisite = {
                codiceStruttura: this.presidio.codiceStruttura
            };
            let sessionStorage = window.sessionStorage;

            sessionStorage.setItem(this.filtroSessionStorage, JSON.stringify(this.filtroTipologieVisite));
            this.$refs.cmpAgendaTipologieVisitaListComponent.loadData();
        },
        onNew() {
            this.$refs.cmpAgendaTipologieVisitaListComponent.onEdit({ id: "-1", imeii: "", sistemaOperativo: "", tipo: "", statoAttuale: "", password: "" });
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage.setItem(this.filtroSessionStorage, JSON.stringify(me.filtroTipologieVisite));
            me.$refs.cmpAgendaTipologieVisitaListComponent.loadData(me.filtroTipologieVisite);
        },
    },
};
</script>
<style scoped>
.button-new {
    border: 1px solid #218838;
}
</style>
